import apiClient from "./apiClient";

export async function forgetPassword(args: { email: string }) {
  await apiClient.post(`/auth/forget-password`, {
    ...args,
  });
  return true;
}

export async function resetPassword(args: {
  token: string;
  newPassword: string;
}) {
  await apiClient.post(`/auth/reset-password`, {
    ...args,
  });
  return true;
}

export async function changePassword(args: {
  currentPassword: string;
  newPassword: string;
}) {
  const res = await apiClient.post(`/auth/change-password`, {
    ...args,
  });
  return res;
}
